import {Sms} from "@falcon/services";
import * as React from "react";
import {PluginTemplates} from "../../../../utils/PluginTemplates";

interface SmsProps {
    sms: Sms;
}

function SmsBlock({sms}: Readonly<SmsProps>): React.JSX.Element {
    return (
        <tr key={sms.id}>
            <td id="document-date" className="muli-semi-bold-16 pt-3">
                <span className="font-weight-extra-light fs-14 ml-2">
                    {PluginTemplates.convertDate(sms.requested, "DD MMMM YYYY")}
                </span>
                <div className={"row ml-2"}>
                    <h5 className={"col-10 pt-3 pl-0"}>{sms.msgText}</h5>
                </div>
            </td>
        </tr>
    );
}

export default SmsBlock;
